<div class="help-center-wrapper">
    <div class="container-fluid" *ngIf="user.superAdmin">
        <form class="mt-1 mb-2" [formGroup]="CSOForm" (ngSubmit)="onSubmit()">
            <div class="row">
                <h4 class="col-12 mb-3">Add new error</h4>
                <div class="col-4">
                    <label for="">Error Reported in Relay UI <span class="text-danger">*</span> </label>
                    <textarea name="error" id="error" cols="30" rows="3" class="form-control form-control-sm" formControlName="error"></textarea>
                    <div *ngIf="submitted && f.error.errors">
                        <div *ngIf="f.error.errors.required" class="text-danger">Value cannot be empty</div>
                    </div>
                </div>
                <div class="col-4">
                    <label for="">Error Description</label>
                    <textarea name="desc" id="desc" cols="30" rows="3" class="form-control form-control-sm" formControlName="errorDescription"></textarea>
                </div>
                <div class="col-4">
                    <label for="">Root cause</label>
                    <textarea name="cause" id="cause" cols="30" rows="3" class="form-control form-control-sm" formControlName="rootCause"></textarea>
                </div>
                <div class="w-100 mt-3"></div>
                <div class="col-6">
                    <label for="contact">What Relay users should do ?</label>
                    <input name="contact" id="contact" type="text" class="form-control form-control-sm" formControlName="contactSupport">
                </div>
                <div class="col-3">
                    <label for="contact">Error reported by <span class="text-danger">*</span></label>
                    <input placeholder="xyz@xyz.com" name="errorReportedBy" id="errorReportedBy" formControlName="errorReportedBy" type="text" class="form-control form-control-sm">
                    <div *ngIf="submitted && f.errorReportedBy.errors" class="text-danger">
                        <div *ngIf="f.errorReportedBy.errors.required">Reported by is required</div>
                        <div *ngIf="f.errorReportedBy.errors.email">Reported by must be a valid email address</div>
                    </div>
                </div>
                <div class="col-3">
                    <label for="">Issue Category <span class="text-danger">*</span></label>
                    <select name="issueCategory" id="issueCategory" class="form-control form-control-sm" formControlName="issueCategory">
                        <option value="">Select category</option>
                        <option [value]="item" *ngFor="let item of issueCategories">{{item}}</option>
                    </select>
                    <div *ngIf="submitted && f.issueCategory.errors">
                        <div *ngIf="f.issueCategory.errors.required" class="text-danger">Issue Category is required</div>
                    </div>
                </div>

            </div>
            <div class="text-right mt-2">
                <button type="submit" class="btn relay-btn save">{{CSOForm.value.id ? 'Update' : 'Save'}}</button>
                <button type="reset" class="btn relay-btn cancel" click="onReset()">Cancel</button>
            </div>
        </form>
    </div>

    <div class="mt-3 ml-3 mr-3 pb-3">
        <h5>List of CSO</h5>
        <div class="row mb-2">
            <div class="col-6">
                <input type="text" class="form-control form-control-sm" [(ngModel)]="term" placeholder="Generic search">
            </div>
        </div>
        <table class="table table-sm table-striped">
            <thead class="thead-dark">
                <tr>
                    <th width="2%" class="text-center">#</th>
                    <th width="25%">Error Reported in Relay UI</th>
                    <th width="25%">Description</th>
                    <th width="15%">Root cause</th>
                    <th width="15%">Relay users should do ?</th>
                    <th *ngIf="user.superAdmin">Reported by</th>
                    <th>Category</th>
                    <th width="8%" *ngIf="user.superAdmin"></th>
                </tr>
            </thead>
            <tbody>
                <tr *ngIf="csoList.length <= 0">
                    <td colspan="6">No data found</td>
                </tr>
                <tr *ngFor="let item of csoList | filter:term;let i = index">
                    <td class="text-center">{{i+1}}</td>
                    <td class="text-break">{{item.error}}</td>
                    <td class="text-break">{{item.errorDescription}}</td>
                    <td class="text-break">{{item.rootCause}}</td>
                    <td class="text-break">{{item.contactSupport}}</td>
                    <td *ngIf="user.superAdmin">{{item.errorReportedBy}}</td>
                    <td>{{item.issueCategory}}</td>
                    <td *ngIf="user.superAdmin" class="text-right">
                        <i class="far fa-edit clickable" (click)="editCSO(item)" ngbTooltip="Edit"></i> |
                        <i class="far fa-trash-alt text-danger clickable" (click)="deleteCSO(item)" ngbTooltip="Delete this item"></i>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>

</div>